import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e207c8ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-header" }
const _hoisted_2 = { style: {"font-size":"22px"} }
const _hoisted_3 = { class: "customer-statistics-page" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-tip" }, "各位售后小伙伴，请仔细查看定金订单客户信息，及时跟进服务", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"right","margin-bottom":"10px"} }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "search-form"
}
const _hoisted_7 = {
  key: 1,
  class: "table-container contLoading"
}
const _hoisted_8 = { style: {"display":"flex","align-items":"center","justify-content":"center","width":"40px","height":"40px","background":"#f5f7fa","border-radius":"50%"} }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "footer" }

import { ref, computed } from 'vue'
import { ElButton } from "element-plus";
import { Picture } from '@element-plus/icons-vue'
import { getListData } from '@/service/main/system'
import { ILoadingInstance } from 'element-plus/lib/el-loading/src/loading.type'
import { ElLoading } from 'element-plus'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
interface TabConfig {
  key: string;
  label: string;
  api: string;
  formItems: Array<{
    label: string;
    prop: string;
    type: 'input' | 'select' | 'date';
    options?: Array<{ label: string; value: string | number }>;
  }>;
  tableColumns: Array<{
    label: string;
    prop: string;
    width?: number;
    showOverflowTooltip?: boolean;
  }>;
}

// 2. 定义 Tab 列表及对应配置

export default /*#__PURE__*/_defineComponent({
  __name: 'tablist',
  emits: ['close'],
  setup(__props, { expose: __expose, emit: __emit }) {

dayjs.locale('zh-cn')

// 1. 定义类型
const tabList: TabConfig[] = [
  {
    key: 'afterSalesDepositOrder',
    label: '售后直播间定金订单客户信息',
    api: '/main/afterSalesLiveQuanzi/queryByConditionWithAuth',
    formItems: [
      { label: '商品名', prop: 'productName', type: 'input' },
      { label: '客户姓名', prop: 'customerName', type: 'input' },
      { label: '微信昵称', prop: 'nickname', type: 'input' },
      { label: '客户unionId', prop: 'unionid', type: 'input' },
      { label: '所属员工', prop: 'empName', type: 'input' },
      {
        label: '签约状态',
        prop: 'signStatus',
        type: 'select',
        options: [
          { label: '未签约', value: 0 },
          { label: '已签约', value: 1 }
        ]
      },
      {
        label: '支付状态',
        prop: 'status',
        type: 'select',
        options: [
          { label: '等待支付', value: 0 },
          { label: '支付成功', value: 10 },
          { label: '已退款', value: 20 },
          { label: '支付关闭', value: 30 },
          { label: '失败（三方订单不存在）', value: 40 },
          { label: '已过期（超过一周未完成支付）', value: 50 }
        ]
      },
    ],
    tableColumns: [
      { label: '客户姓名', prop: 'customerName', width: 100 },
      { label: '微信昵称', prop: 'nickname', width: 100 },
      { label: '头像', prop: 'avatar', width: 80 },
      { label: '客户unionId', prop: 'unionid', width: 150 },
      { label: '直播间名称', prop: 'channelName', width: 120 },
      { label: '商品名', prop: 'productName', width: 150 },
      { label: '支付金额', prop: 'price', width: 100 },
      { label: '签约状态', prop: 'signStatus', width: 100 },
      { label: '所属部门', prop: 'deptName', width: 100 },
      { label: '所属员工', prop: 'empName', width: 100 },
      { label: '下单时间', prop: 'orderCreateTime', width: 150 },
      { label: '支付时间', prop: 'payTime', width: 150 },
      { label: '支付单号', prop: 'orderId', width: 150 },
      { label: '支付状态', prop: 'status', width: 100 },
      { label: '支付渠道', prop: 'channelCode', width: 120 },
      { label: '是否退款', prop: 'isRefund', width: 100 },
      { label: '退款金额', prop: 'refundAmount', width: 100 },
    ],
  },
];

// 3. 响应式数据
const activeTab = ref<string>(tabList[0].key);
const tableData = ref<any[]>([]);
const currentForm = ref<Record<string, any>>({});

// 4. 计算属性：获取当前激活 Tab 的配置
const currentTabConfig = computed(() => {
  return tabList.find((tab) => tab.key === activeTab.value);
});

// 字典数据配置
const dictOptions = {
  signStatus: [
    { value: 0, label: '未签约' },
    { value: 1, label: '已签约' }
  ],
  status: [
    { value: 0, label: '等待支付' },
    { value: 10, label: '支付成功' },
    { value: 20, label: '已退款' },
    { value: 30, label: '支付关闭' },
    { value: 40, label: '失败（三方订单不存在）' },
    { value: 50, label: '已过期（超过一周未完成支付）' }
  ],
  channelCode: [
    { value: 'wallet', label: '钱包' },
    { value: 'mock', label: '模拟支付' },
    { value: 'alipay_qr', label: '支付宝扫码支付' },
    { value: 'alipay_bar', label: '支付宝条码支付' },
    { value: 'alipay_app', label: '支付宝 App 支付' },
    { value: 'alipay_wap', label: '支付宝 Wap 网站支付' },
    { value: 'alipay_pc', label: '支付宝 PC 网站支付' },
    { value: 'wx_bar', label: '微信条码支付' },
    { value: 'wx_native', label: '微信扫码支付' },
    { value: 'wx_app', label: '微信 App 支付' },
    { value: 'wx_lite', label: '微信小程序支付' },
    { value: 'wx_pub', label: '微信公众号支付' },
    { value: 'wx_wap', label: '微信 Wap 网站支付' }
  ]
}

// 字典转义方法
const getDictName = (dictType: string, value: any) => {
  const options = dictOptions[dictType as keyof typeof dictOptions]
  if (!options || value === null || value === undefined) {
    return value || ''
  }
  const item = options.find((opt) => opt.value === value)
  return item ? item.label : value
}

const page = ref({
  pageNo: 1,
  pageSize: 10,
  total: 0
})

let loadingInstance: ILoadingInstance = {} as ILoadingInstance

// Tab 切换时重置表单
const handleTabChange = () => {
  resetForm();
};

// 重置表单
const resetForm = () => {
  if (!currentTabConfig.value) return;
  currentForm.value = currentTabConfig.value.formItems.reduce((obj, item) => {
    obj[item.prop] = '';
    return obj;
  }, {} as Record<string, any>);
  page.value.pageNo = 1
  loadTableData();
};

// 查询方法
const handleSearch = () => {
  console.log('查询条件：', currentForm.value, 'Tab：', activeTab.value);
  loadTableData();
};

const handleSizeChange = (pageSize: number) => {
  page.value.pageSize = pageSize
  loadTableData()
}

const handleCurrentChange = (pageNo: number) => {
  page.value.pageNo = pageNo
  loadTableData()
}

const emit = __emit;

function closePop() {
  dialogVisible.value = false
  emit('close')
}

// 加载表格数据
const loadTableData = async () => {
  if (!currentTabConfig.value?.api) return;

  if (document.querySelector('.contLoading')) {
    if (loadingInstance && typeof loadingInstance.close === 'function') {
      loadingInstance.close()
    }
    loadingInstance = ElLoading.service({
      target: '.contLoading',
      text: '加载中....',
      spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, 0.8)',
      fullscreen: false
    })
  }

  try {
    let obj = {
      pageNo: page.value.pageNo,
      pageSize: page.value.pageSize,
      sysDate: currentRow.value.date
    }
    const res = await getListData(currentTabConfig.value.api, { ...currentForm.value, ...obj })
    if (res) {
      tableData.value = res.records ? res.records : res?.list ? res.list : []
      page.value.total = Number(res.total)
    }
  } catch (error) {
    tableData.value = []
  } finally {
    if (loadingInstance && typeof loadingInstance.close === 'function') {
      loadingInstance.close()
    }
  }
};

// 弹窗相关数据
const dialogVisible = ref(false)
const currentRow = ref<any>(null)
const title = ref('')

/** 打开弹窗 */
const open = async (row: any) => {
  dialogVisible.value = true
  currentRow.value = row
  title.value = currentRow.value.date + '售后通知记录'
  resetForm();
}

__expose({ open })

return (_ctx: any,_cache: any) => {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
    fullscreen: true,
    "show-close": false
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(title.value), 1),
        _createVNode(_unref(ElButton), {
          type: "danger",
          icon: "el-icon-close",
          size: "small",
          onClick: closePop,
          style: {"position":"absolute","top":"0","right":"10px"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 关闭 ")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createVNode(_component_el_radio_group, {
          modelValue: activeTab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
          fill: "#409eff",
          onChange: handleTabChange
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabList, (tab) => {
              return _createVNode(_component_el_radio_button, {
                key: tab.key,
                label: tab.key
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tab.label), 1)
                ]),
                _: 2
              }, 1032, ["label"])
            }), 64))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (currentTabConfig.value?.formItems?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_el_form, {
                model: currentForm.value,
                inline: "",
                onSubmit: _withModifiers(handleSearch, ["prevent"]),
                class: "mb-4"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentTabConfig.value.formItems, (formItem) => {
                    return (_openBlock(), _createBlock(_component_el_form_item, {
                      key: formItem.prop,
                      label: formItem.label
                    }, {
                      default: _withCtx(() => [
                        (formItem.type === 'input')
                          ? (_openBlock(), _createBlock(_component_el_input, {
                              key: 0,
                              modelValue: currentForm.value[formItem.prop],
                              "onUpdate:modelValue": ($event: any) => ((currentForm.value[formItem.prop]) = $event),
                              placeholder: `请输入${formItem.label}`,
                              clearable: ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                          : (formItem.type === 'select')
                            ? (_openBlock(), _createBlock(_component_el_select, {
                                key: 1,
                                modelValue: currentForm.value[formItem.prop],
                                "onUpdate:modelValue": ($event: any) => ((currentForm.value[formItem.prop]) = $event),
                                placeholder: `请选择${formItem.label}`,
                                clearable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formItem.options || [], (option) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: option.value,
                                      label: option.label,
                                      value: option.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                            : (formItem.type === 'date')
                              ? (_openBlock(), _createBlock(_component_el_date_picker, {
                                  key: 2,
                                  modelValue: currentForm.value[formItem.prop],
                                  "onUpdate:modelValue": ($event: any) => ((currentForm.value[formItem.prop]) = $event),
                                  type: "date",
                                  placeholder: `请选择${formItem.label}`,
                                  clearable: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                              : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128)),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElButton), {
                        type: "primary",
                        onClick: handleSearch
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("查询")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(ElButton), { onClick: resetForm }, {
                        default: _withCtx(() => [
                          _createTextVNode("重置")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]))
          : _createCommentVNode("", true),
        (currentTabConfig.value?.tableColumns?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_el_table, {
                data: tableData.value,
                border: "",
                stripe: "",
                style: {"width":"100%"},
                "max-height": "500",
                columns: currentTabConfig.value.tableColumns
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentTabConfig.value.tableColumns, (column) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      key: column.prop,
                      prop: column.prop,
                      label: column.label,
                      "min-width": column.width,
                      "show-overflow-tooltip": column.showOverflowTooltip
                    }, _createSlots({ _: 2 }, [
                      (column.prop === 'signStatus')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(getDictName('signStatus', scope.row.signStatus)), 1)
                            ]),
                            key: "0"
                          }
                        : undefined,
                      (column.prop === 'status')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(getDictName('status', scope.row.status)), 1)
                            ]),
                            key: "1"
                          }
                        : undefined,
                      (column.prop === 'channelCode')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(getDictName('channelCode', scope.row.channelCode)), 1)
                            ]),
                            key: "2"
                          }
                        : undefined,
                      (column.prop === 'price')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, "￥" + _toDisplayString(parseFloat((scope.row.price / 100).toFixed(2))), 1)
                            ]),
                            key: "3"
                          }
                        : undefined,
                      (column.prop === 'refundAmount')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, "￥" + _toDisplayString(parseFloat((scope.row.refundAmount / 100).toFixed(2))), 1)
                            ]),
                            key: "4"
                          }
                        : undefined,
                      (column.prop === 'avatar')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              (scope.row.avatar)
                                ? (_openBlock(), _createBlock(_component_el_image, {
                                    key: 0,
                                    src: scope.row.avatar,
                                    "preview-src-list": [scope.row.avatar],
                                    fit: "cover",
                                    style: {"width":"40px","height":"40px","border-radius":"50%","cursor":"pointer"}
                                  }, {
                                    error: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_8, [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Picture))
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["src", "preview-src-list"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_9, "-"))
                            ]),
                            key: "5"
                          }
                        : undefined
                    ]), 1032, ["prop", "label", "min-width", "show-overflow-tooltip"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "columns"]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_pagination, {
                  "current-page": page.value.pageNo,
                  "page-sizes": [10, 20, 30, 40, 100],
                  "page-size": page.value.pageSize,
                  layout: "total, prev, pager, next, jumper",
                  total: page.value.total,
                  onSizeChange: handleSizeChange,
                  onCurrentChange: handleCurrentChange
                }, null, 8, ["current-page", "page-size", "total"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})